<table ixTest="summary-table">
  <ng-container *ngFor="let section of summary">
    <tr
      *ngFor="let item of section; let i = index"
      class="summary-line"
      [ixTest]="['summary', item.label]"
      [class.section-start]="i === 0"
    >
      <td class="summary-line-label">{{ item.label }}:</td>
      <td class="summary-line-value">{{ item.value }}</td>
    </tr>
  </ng-container>
</table>
